module.exports = __webpack_public_path__ + "img/logo-ex.b028561a.png";